import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { parse } from "date-fns";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import { DEVELOPMENT_TYPE } from "Constants";
import { openSessionModal } from "ContentActions";
import { HEIGHT_PER_HOUR } from "ScheduleConstants";
import LocaleStrings from "Languages";

class FakeScheduleItem extends Component {
  onAddSessionClick = () => {
    var { backgroundcolor } = this.props.sessionColors
      ? _.shuffle(this.props.sessionColors)[0]
      : { backgroundcolor: "#FDAFBD" };

    if (DEVELOPMENT_TYPE === "koachify") {
      this.props.openSessionModal({
        status: true,
        otherdata: { backgroundcolor: backgroundcolor },
        session: {},
      });
    } else {
      this.props.openSessionModal({
        status: true,
        otherdata: { backgroundcolor: backgroundcolor },
        session: {
          scheduletrackid: this.props.track.scheduletrackid,
          toaddwithtrackid: "1",
        },
      });
    }
  };

  render() {
    let { sessionScreenZoom } = this.props;
    var dateTimes = {}; // This is used to store each date first evet time (hour)
    var startTimes = [];
    var actualStartHourPixels = 0;

    if (this.props.sessionByEventsArray) {
      this.props.sessionByEventsArray.map((item) => {
        var onlyDate = item.starttime.substring(0, 10);
        if (dateTimes[onlyDate]) {
          if (dateTimes[onlyDate] > item.starttime.substring(11, 13)) {
            dateTimes[onlyDate] = item.starttime.substring(11, 13);
          }
        } else {
          dateTimes[onlyDate] = item.starttime.substring(11, 13);
        }
      });

      var dateClickedOn = this.props.selectedScheduleDate.scheduledate;
      var minTime = dateTimes[dateClickedOn];
      var firstEventHour = minTime; //First event time hour of selected date
      var heightPerHour = !_.isEmpty(sessionScreenZoom)
        ? sessionScreenZoom.height
        : HEIGHT_PER_HOUR; //Height per pixel calculated on hour
      var heightPerMinute = heightPerHour / 60; //Height per minute

      // var nowStart = new Date(this.props.schedule.starttime);
      var nowStart = parse(
        moment(this.props.schedule.starttime).format("DD-MM-YYYY HH:mm:ss"),
        "dd-MM-yyyy HH:mm:ss",
        new Date()
      );
      var startDate = new Date(
        nowStart.getTime() - nowStart.getTimezoneOffset() * 60000
      );

      var startHour = startDate.getUTCHours();
      var startMin = startDate.getUTCMinutes();

      //console.log("Start Hour =",startHour," Start Minute = ",startMin+"\n");

      // var nowEnd = new Date(this.props.schedule.endtime);
      var nowEnd = parse(
        moment(this.props.schedule.endtime).format("DD-MM-YYYY HH:mm:ss"),
        "dd-MM-yyyy HH:mm:ss",
        new Date()
      );
      var endDate = new Date(
        nowEnd.getTime() - nowEnd.getTimezoneOffset() * 60000
      );

      var endHour = endDate.getUTCHours();
      var endMin = endDate.getUTCMinutes();

      //console.log("End Hour =",endHour," End Minute = ",endMin+"\n");

      var diffHours = endHour - startHour;
      var diffMins = endMin - startMin;

      // below code is added, as we have removed validation of end time should be bigger than start time from new session add, this code is also added in schedule_item.js file
      if (nowStart.getTime() > nowEnd.getTime()) {
        diffHours = startHour - endHour;
        diffMins = startMin - endMin;
      }

      if (this.props.scheduleSession.length > 0) {
        actualStartHourPixels =
          ((startHour - firstEventHour) * 60 + startMin) * heightPerMinute;
        var heightForHour = (diffHours * 60 + diffMins) * heightPerMinute;

        actualStartHourPixels = actualStartHourPixels + heightForHour;
      }
    }

    var mainDivStyle = {
      backgroundColor: "#664fc8",
      borderRadius: "5px",
      padding: "12px 20px",
      position: "absolute",
      margin: "0px 20px 0px 20px",
      top: `${actualStartHourPixels}px`,
      left: "15px",
      textAlign: "center",
      color: "#ffffff",
      height: "40px",
      fontSize: "12px",
    };
    var mainDivStyle1 = {
      position: "absolute",
      margin: "5px 20px 0px 20px",
      top: `${actualStartHourPixels}px`,
      left: "15px",
    };

    return (
      <div>
        {/* <div
          style={mainDivStyle}
          className="session-item btn-v-center"
          onClick={this.onAddSessionClick}
        >
          <i
            className="fa fa-plus i-custom-m"
            style={{ marginRight: 6 }}
            aria-hidden="true"
          />{" "}
          {LocaleStrings.button_new_session}
        </div> */}
        <Button
          bsStyle=""
          className="btn-custom-blue"
          type="button"
          style={mainDivStyle1}
          onClick={this.onAddSessionClick}
        >
          <img
            src="../../style/images/header-icons/plus.png"
            style={{ paddingBottom: 3, paddingRight: 4 }}
            aria-hidden="true"
          ></img>{" "}
          {LocaleStrings.button_new_session}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var sessionByEventsArray;

  if (state.scheduleData.payload.session_by_eventid) {
    sessionByEventsArray = state.scheduleData.payload.session_by_eventid;
  }

  return {
    selectedScheduleDate: state.selectedScheduleDate,
    sessionByEventsArray: sessionByEventsArray,
    sessionColors: state.sessionColors.payload,
    sessionScreenZoom: state.sessionScreenZoom,
  };
}

export default connect(mapStateToProps, { openSessionModal })(FakeScheduleItem);
